<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          PROFILE
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Profile List
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" @click="getData()">refresh</v-icon>
          </v-flex>
          <v-flex xs4 class="my-5">
            <v-text-field
              id="search"
              v-model="search"
              append-icon="search"
              placeholder="Search by name"
              single-line
              hide-details
              @keyup="searchProfile()"
            ></v-text-field>
          </v-flex>
          <v-flex xs8 class="text-right">
            <v-btn
              id="add-profile"
              depressed
              color="secondblue"
              class="white--text"
              :to="{ name: 'profileCreate' }"
            >
              <v-icon left dark>add</v-icon>
              Add new profile
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :must-sort="true"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-desc.sync="descending"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <template slot="items"> </template>
          <template v-slot:item.created_by="{ item }">
            {{
              item.logCreate
                ? item.logCreate.length > 0
                  ? item.logCreate[0].user.email
                  : '-'
                : '-'
            }}
          </template>
          <template v-slot:item.updated_by="{ item }">
            {{
              item.logUpdate
                ? item.logUpdate.length > 0
                  ? item.logUpdate[0].user.email
                  : '-'
                : '-'
            }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn icon :id="'btn-detail' + item.id" @click="toDetail(item.id)">
              <v-icon color="green">remove_red_eye</v-icon>
            </v-btn>
            <router-link
              v-if="hasPermission('update_master_data', 'update')"
              :to="{
                name: 'profileEdit',
                params: { id: item.id }
              }"
              class="text-decoration-none"
            >
              <v-btn icon :id="'btn-edit' + item.id" @click="toEdit(item.id)">
                <v-icon color="secondblue">mdi-square-edit-outline</v-icon>
              </v-btn>
            </router-link>
          </template>
          <template v-slot:no-data>
            <label color="primary">No data displayed</label>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import paginationMixin from '../../../mixins/paginationMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      progressDialogLoading: true,
      loading: true,
      descending: true,
      search: '',
      isSearch: false,
      sort: '',
      items: [],
      totalItems: 0,
      options: {},
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Profile List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'desc'
        },
        {
          text: 'Created At',
          value: 'created_at',
          sortable: false
        },
        {
          text: 'Created By',
          value: 'created_by',
          sortable: false
        },
        {
          text: 'Updated At',
          value: 'updated_at',
          sortable: false
        },
        {
          text: 'Updated By',
          value: 'updated_by',
          sortable: false
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],
      timeout: null
    };
  },
  watch: {
    descending() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    searchProfile() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
      // setTimeout(() => {
      //   this.getData()
      // }, 900)
    },
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      let { page } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      let { itemsPerPage } = this.options;
      const search = {
        desc: this.search
      };
      return this.$store
        .dispatch('profile/getAll', {
          page,
          sort,
          limit: itemsPerPage,
          search
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.totalItems = data.data.total_data;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        });
    },
    toEdit(value) {
      this.$router.push({
        params: { id: value },
        name: 'profileEdit'
      });
    },
    toDetail(value) {
      this.$router.push({
        params: { id: value },
        name: 'profileDetail'
      });
    }
  }
};
</script>
